// ABOUTME: Fills in a page title for links added without a name, via /api/link-title.
// ABOUTME: The title applies only while the link is still unnamed, so a user's own name always wins.

import type { DashboardItem } from "./dashboardService";
import { isUnnamed } from "../utils/linkLabel";

/** The page's title from the link-title function, or null on any failure. */
export async function fetchLinkTitle(url: string): Promise<string | null> {
  try {
    const res = await fetch(`/api/link-title?url=${encodeURIComponent(url)}`);
    if (!res.ok) return null;
    const body: unknown = await res.json();
    const title = (body as { title?: unknown } | null)?.title;
    return typeof title === "string" && title.trim() ? title.trim() : null;
  } catch {
    return null;
  }
}

interface BackfillDeps {
  /** The item as it is now, read when the title arrives rather than when it was asked for. */
  getItem: (id: string) => DashboardItem | undefined;
  update: (id: string, patch: Partial<DashboardItem>) => unknown;
  fetchTitle?: (url: string) => Promise<string | null>;
}

/** Names a just-added link after its page, unless it was renamed, edited or deleted meanwhile. */
export async function backfillLinkTitle(
  id: string,
  url: string,
  { getItem, update, fetchTitle = fetchLinkTitle }: BackfillDeps
): Promise<void> {
  const title = await fetchTitle(url);
  if (!title) return;
  const item = getItem(id);
  if (!item || item.url !== url || !isUnnamed(item)) return;
  await update(id, { name: title });
}
